var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bike"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-1",
    d: "M24.33,4.38l.48,1.94-2.94.73L24,13.17A6.43,6.43,0,0,1,25.5,13a6.51,6.51,0,1,1-3.33.92h0L21,10.54l-.2,0-3,9.92H12.92a6.52,6.52,0,1,1,0-2h1.61l-5-8.28,10.8-1.59-1-3ZM6.5,15A4.5,4.5,0,1,0,11,19.5,4.51,4.51,0,0,0,6.5,15Zm19,0A4.5,4.5,0,1,0,30,19.5,4.51,4.51,0,0,0,25.5,15Zm-19,3A1.5,1.5,0,1,1,5,19.5,1.5,1.5,0,0,1,6.5,18Zm19,0A1.5,1.5,0,1,1,24,19.5,1.5,1.5,0,0,1,25.5,18Zm-6.91-7.1-5.81.85,3.68,6.09ZM12,6V8H6V6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.18e88e54.svg";
export { ForwardRef as ReactComponent };